import { NgModule } from "@angular/core";

import { GridModule } from "@progress/kendo-angular-grid";
import { PanelBarModule } from '@progress/kendo-angular-layout';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';

@NgModule({
    imports: [
        DialogsModule,
        ButtonModule,
        GridModule,
        PanelBarModule,
        InputsModule,
        LabelModule,
        DropDownsModule,
    ],
    exports: [
        DialogsModule,
        ButtonModule,
        GridModule,
        PanelBarModule,
        InputsModule,
        LabelModule,
        DropDownsModule
    ]
})
export class KendoUiModule { }
